import { TriggerEntityModel } from "src/store/models/entity/trigger/entity";
import { TriggerHelperModel } from "src/store/models/entity/trigger/helper";

export const encooTriggerModels = {
  entity: TriggerEntityModel,
  helper: TriggerHelperModel,
};
